module.exports = __webpack_public_path__ + "img/water-arrow-up.6ecad33e.svg";